import Select, { SelectProps } from "@/shared/form/select";

import { DynamicAttributeType } from "gql/graphql";
import { useTranslations } from "use-intl";

export function DynamicAttributeTypeSelect(props: SelectProps) {
  const t = useTranslations("DynamicAttributeTypeSelect");

  return (
    <Select
      placeholder={t("Select type")}
      options={Object.keys(DynamicAttributeType).map((key: string) => ({
        label: t(
          DynamicAttributeType[key as keyof typeof DynamicAttributeType],
        ),
        value: DynamicAttributeType[key as keyof typeof DynamicAttributeType],
      }))}
      {...props}
    />
  );
}
